import { render, staticRenderFns } from "./Fallback.vue?vue&type=template&id=6e1bf77d&"
import script from "./Fallback.vue?vue&type=script&lang=js&"
export * from "./Fallback.vue?vue&type=script&lang=js&"
import style0 from "./Fallback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports